import api from '../services/api';
import { createBaseModule } from './base';


export default createBaseModule( {
  state: {
    success: {},
    redirect: '',
    save_error: []
  },
  mutations: {
    SET_ORDER_SUCCESS(state, success) {
      debugger;
      state.success = success.data;
    },
  },
  actions: {
    async fetchOrder({ commit, state }) {
      //commit('RESET_STATE');

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/order/fields/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message || 'Ошибка при загрузке');
        console.error('Error fetching blog:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async saveOrder({ commit, state, dispatch }, data) {
      //commit('UNSET_ORDER');
      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.post('api/order/',
            data, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

        dispatch('counter/fetchCounterData', true, { root: true })
        if (response.data.status == 'success') {
          //dispatch('fetchCounterData', true);
          commit('SET_ORDER_SUCCESS', response.data);
          if (response.data.data) {
            commit('SET_ORDER', response.data);
          }
          //commit('SET_ORDER_ERROR', null);
          return true;
        }
        else {
          /*let serverError= [];
          for (let i in response.data.errors) {
             serverError.push(response.data.errors[i].message);
          }*/
          return response.data.errors;
        }
      } catch (error) {
        dispatch('counter/fetchCounterData', true, { root: true })
        //commit('SET_ORDER_ERROR', error.message || 'Ошибка при загрузке категорий');
        return error.message;
      } finally {
        //commit('SET_ORDER_LOADING', false);
      }

    }
  },
  getters: {
    order: state => state.data,
    orderLoading: state => state.loading,
    orderError: state => state.error,
    orderLoaded: state => state.loaded,
    success: state => state.success,
    redirect: state => state.redirect
  }
})